import { Tabs } from "shared/components/Tabs";
import { CountNotification } from "shared/app/ApplicationsTableView/components/CountNotification";
import {
  ShowingNotesType,
  useNotesController
} from "shared/queries/useNotesController";
import { cx } from "shared/utils";

const tabs = [
  {
    key: ShowingNotesType.ALL,
    label: "All"
  },
  {
    key: ShowingNotesType.MENTIONS,
    label: "Mentions"
  }
];

export const NotesTabs = ({
  notesController,
  tabClassName
}: {
  notesController: ReturnType<typeof useNotesController>;
  tabClassName?: string;
}) => {
  return (
    <Tabs
      tabClassName={cx("ml-6", tabClassName)}
      variant="underline"
      setActiveTab={(tab) =>
        notesController.changeShowingNotesType(tab as ShowingNotesType)
      }
      selected={notesController.showingNotesType}
      displayMap={{
        [ShowingNotesType.ALL]: "All",
        [ShowingNotesType.MENTIONS]: (
          <span className="flex items-center gap-2">
            Mentions
            <CountNotification
              totalCount={notesController.mentionNotesCount}
              className="px-1.5"
            />
          </span>
        )
      }}
      tabs={tabs.map((tab) => tab.key)}
    />
  );
};
